/* eslint-disable no-bitwise */
/* eslint-disable react/no-array-index-key */
import React from 'react';
import {
  PieChart,
  Pie,
  Tooltip,
  ResponsiveContainer,
  Cell,
  Legend,
} from 'recharts';
import { Box, CircularProgress, Typography } from '@mui/material';
import { useGetDashboardGroupedDataQuery } from '../services/dashboard.endpoints';

// Deterministic hash function to generate a hex color code
const hashStringToColor = (str: string): string => {
  let hash = 0;
  for (let i = 0; i < str.length; i += 1) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  const color = `#${((hash >> 24) & 0xff).toString(16).padStart(2, '0')}${(
    (hash >> 16) &
    0xff
  )
    .toString(16)
    .padStart(2, '0')}${((hash >> 8) & 0xff).toString(16).padStart(2, '0')}`;
  return color.slice(0, 7); // Return a 6-character color code
};

const generateColors = (data: any[]) => {
  return data.map((item) =>
    hashStringToColor(item.productName || String(item._id)),
  );
};

const UsersByProductChart = () => {
  const { data, error, isLoading } = useGetDashboardGroupedDataQuery();

  if (isLoading) return <CircularProgress />;
  if (error) return <Typography>Error loading data</Typography>;

  const usersByProductData = data?.usersByProduct || [];
  const COLORS = generateColors(usersByProductData);

  const formatted = usersByProductData.map((item, index) => {
    return {
      // _id: item._id,
      value: item.userCount,
      name: item.productName,
      color: COLORS[index],
    };
  });

  return (
    <Box>
      <ResponsiveContainer width="100%" height={300}>
        <PieChart>
          <Pie
            data={formatted}
            dataKey="value"
            outerRadius={150}
            fill="#82ca9d"
            cx="50%" // Center the pie chart horizontally
            cy="50%" // Center the pie chart vertically
          >
            {usersByProductData.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={COLORS[index]} />
            ))}
          </Pie>
          <Tooltip />
          <Legend
            layout="vertical"
            verticalAlign="middle"
            align="right"
            payload={formatted.map((item, index) => ({
              id: item.name,
              type: 'square',
              value: `${item.name}`, // Product name in the legend
              color: COLORS[index], // Use the same color as the pie segment
            }))}
          />
        </PieChart>
      </ResponsiveContainer>
    </Box>
  );
};

export default UsersByProductChart;
